import * as React from "react";
import {BlindsStructure, Level, PayoutStructure} from "../../../../generated/protocol";
import {Form, FormListener} from "../../form/Form";
import {FormSubmitError, FormSubmitSuccess} from "../../form/FormFeedback";
import {Submit} from "../../form/Submit";
import {FormGroup} from "../../form/FormGroup";
import {FormInput} from "../../form/FormInput";
import {Validators} from "../../form/Validators";
import {BindModel, FormList, FormListItem, ListItemBinding, ModelBinding} from "../../form/FormList";
import {RangeInput} from "../../form/RangeInput";

interface Props {
    structure?: PayoutStructure;
    validationMap?: any;
    formListener?: FormListener<PayoutStructure>;
    onSuccessClose?: () => void;
}

interface State {

}

export class PayoutStructureForm extends React.Component<Props, State> {


    render() {

        return (
            <Form className="form-horizontal" formListener={this.props.formListener} modelObject={this.props.structure}
                  validationMap={this.props.validationMap}>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="ibox float-e-margins">
                            <div className="ibox-title">
                                <h5>Blinds Info</h5>
                            </div>
                            <div className="ibox-content">
                                <div className="hr-line-dashed"></div>
                                <FormGroup className="form-group" model="name">
                                    <label className="col-sm-2 control-label ">Name</label>
                                    <div className="col-sm-10">
                                        <FormInput model="name" type="text" className="form-control name"
                                                   validators={[Validators.required()]}/>
                                    </div>
                                </FormGroup>
                                <div className="hr-line-dashed"></div>
                                <FormList model="payoutsPerEntryRange">
                                    <RangeInput className="form-control" from="entrantsRange.start"
                                                to="entrantsRange.stop"/>
                                    <FormList model="payoutList">
                                        <RangeInput className="form-control" from="positionRange.start"
                                                    to="positionRange.stop"/>
                                    </FormList>
                                </FormList>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-12">
                        <div className="ibox float-e-margins">
                            <div className="ibox-title">
                                <h5>Payouts</h5>
                            </div>
                            <div className="ibox-content">

                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-12">
                        <div className="ibox float-e-margins">
                            <div className="ibox-content">
                                <div className="ibox-title">
                                    <h5>Actions</h5>
                                </div>
                                <FormSubmitError/>
                                <FormSubmitSuccess text="Tournament was updated successfully"
                                                   onClose={() => this.props.onSuccessClose()}/>
                                <div className="form-group">
                                    <div className="col-sm-10 col-sm-offset-2">
                                        <Submit className="ladda-button btn-lg btn-primary">Save Payout
                                            Structure</Submit>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Form>
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/ui/poker/tournament/PayoutStructureForm.tsx